import { render, staticRenderFns } from "./EmpresarialView.vue?vue&type=template&id=04a3bd8b"
import script from "./EmpresarialView.vue?vue&type=script&lang=js"
export * from "./EmpresarialView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports